import styled from 'styled-components'
import { CtaType, ListElementProps } from './types'

export const ListElement = ({ id,
  onSelectElement,
  title,
  caption,
  otherElementData,
  image,
  ctaType,
  ctaTitle }: ListElementProps) => {
  const handleClick = () => {
    onSelectElement({ id, title, caption, otherElementData })
  }

  return (
    <StyledSelectElement
      key={id}
      className="vb-flex-row-spb-c"
      onClick={handleClick}
    >
      <StyledElementContainer>
        <StyledElementImage src={image}/>
        <StyledElementContent className="vb-flex-row-fs-c">
          <TitleWithCaption >
            <StyledTitleElement>{title}</StyledTitleElement>
            <StyledCaptionElement>{caption}</StyledCaptionElement>
          </TitleWithCaption>
        </StyledElementContent>
      </StyledElementContainer>
      <CtaElement type={ctaType}>
        {ctaTitle}
      </CtaElement>
    </StyledSelectElement>
  )
}

export const CtaElement = ({ type, children }: { type: CtaType; children: React.ReactNode }) => {
  switch (type) {
    case CtaType.PRIMARY:
      return <CtaElementPrimary>{children}</CtaElementPrimary>
    case CtaType.OUTLINE:
      return <CtaElementOutline>{children}</CtaElementOutline>
    default:
      return <CtaElementPrimary>{children}</CtaElementPrimary>
  }
}


const StyledSelectElement = styled.div`
  width: 100%;
`

const CtaElementPrimary = styled.button`
  padding: 6px 10px;
  background-color: var(--color-green-new);
  color: var(--color-dark-green-new);
  border-radius: 6px;
  font-size: 12px
  font-weight: 500;
  border: none;
  cursor: pointer;
`

const CtaElementOutline = styled.button`
  padding: 6px 10px;
  background-color: transparent;
  color: var(--color-black-light-new);
  border: 1px solid var(--color-black-light-new);
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
`

const StyledCaptionElement = styled.span`
color: var(--font-color-gray-light-new);
font-weight: 500;
font-size: 12px;
`

const StyledTitleElement = styled.span`
color: var(--color-black-light-new);
font-weight: 600;
font-size: 14px;
`
const StyledElementContent = styled.div`
  max-width: calc(100% - 28px);
  display: flex;
`

const StyledElementContainer = styled.div`
  display: flex;
  gap: 15px;
  padding: 15px 0;
`

const StyledElementImage= styled.img`
  display: flex;
  height: 34px;
  width: 34px;
  border-radius: 100%;
`

const TitleWithCaption = styled.div`
   display: flex;
   flex-direction: column;
`
